<div class="container-summary">
    <h1 class="twc-h1">{{ 'WIZARD.TAB_SUMMARY' | translate }}</h1>

    <div class="twc-mb-3 twc-message-box twc-message-box-info"
        *ngIf="showImportZipProjectWarning()">
        {{'UPLOAD.WARNING_0_ImportZipProject' | translate}}
    </div>

    <div class="twc-mt-1 twc-mb-3" *ngIf="subtitle">{{subtitle | translate}}</div>

    <div class="twc-row">
        <div class="twc-col-12">
            <div class="twc-d-flex summary-header">
                <h3 class="twc-h3">
                    {{'WIZARD.TAB_FILES' | translate}}
                </h3>
                <button class="twc-button twc-button-primary" *ngIf="showUploadMoreData()"
                    (click)="uploadWizardService.uploadMoreData()">
                    {{'UPLOAD.UPLOAD_MORE_DATA' | translate}}
                </button>
            </div>
            <cw-upload-list [files]="uploadWizardService.files" [uploadInfo]="uploadWizardService.uploadConfig"
                [showUploadControlButtons]="showUploadControlButtons()"
                (cancelUpload)="uploadWizardService.cancelUpload()" (pauseUpload)="uploadWizardService.pauseUpload()"
                (resumeUpload)="uploadWizardService.resumeUpload()">
            </cw-upload-list>
            <div class="twc-mt-3" *ngIf="uploadWizardService.isLayer()">
                <b class="twc-mr-2">{{'UPLOAD.FIELD_CRS' | translate}}:</b>
                {{ uploadWizardService.crsValue.value || 'UPLOAD.FIELD_CRS_NOT_SET' | translate}}
            </div>
        </div>
    </div>

    <div class="summary-info twc-row twc-mt-5">
        <ng-container *ngFor="let summary of uploadWizardService.summary">
            <div class="twc-col-12" *ngIf="summary">
                <h3 class="twc-h3" *ngIf="summary.title">
                    {{ summary.title | translate}}
                </h3>
                <div class="twc-ml-3">
                    <ng-container *ngIf="summary.errors">
                        <div class="twc-col-12 twc-body" *ngFor="let error of summary.errors">
                            <div class="twc-message-box twc-message-box-error">{{error | translate}}</div>
                        </div>
                    </ng-container>

                    <div class="twc-col-12 twc-body" *ngIf="summary.notice">
                        <span>{{ summary.notice | translate}}</span>
                    </div>

                    <div class="twc-col-12 twc-body twc-d-flex" *ngFor="let field of summary.fields">
                        <b class="twc-mr-3 summary-text-field">{{ field.key | translate}}:</b>
                        <span>{{ field.value | translate}}</span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div *ngIf="showEstimationMessage" class="twc-mt-4 twc-message-box twc-message-box-warning">
        {{'SCANPROC.CREDIT_CANNOT_BE_ESTIMATED' | translate}}
    </div>
</div>